import { FC, memo } from 'react';

import V2AreasPresenter from './V2AreasPresenter';

const V2Areas: FC = memo(() => (
  <V2AreasPresenter />
));

export default V2Areas;
